// extracted by mini-css-extract-plugin
module.exports = {"button":"StoreFinderLegacy_button__ddfG5","ghostButton":"StoreFinderLegacy_ghostButton__oyWyz"};